import React from 'react'
import PropTypes from 'prop-types'
import LoginForm from './components/LoginForm'
import queryString from 'query-string'
import AppRoutes from '../../routes/appRoutes'
import L1NLogoWhiteStroke from '../../svg/L1N-logo-white-stroke.svg'
import LoginTransition from './components/LoginTransition'
import DisabledLink from './components/DisabledLink'
import { useNetworkStatus } from '../../utils/networkStatus'
import { isEnvForcedMaintenanceMode } from '../../utils/maintenanceEnv'

export default function LoginPage(props) {
    const values = props.location
        ? queryString.parse(props.location.search)
        : {}
    const redirect = values.redirect ? values.redirect : AppRoutes.dashboard()
    const { isOffline } = useNetworkStatus()
    const loginUnavailable = isOffline || isEnvForcedMaintenanceMode()

    return (
        <LoginTransition>
            <div className="transition-all w-full flex flex-col items-center justify-start sm:p-16 p-6 sm:gap-y-10 gap-y-6">
                <section className="flex flex-col items-center justify-start w-full">
                    <img className="h-8 w-28" src={L1NLogoWhiteStroke} />
                    <h1 className="sm:text-3xl text-2.5xl mt-4 font-bold text-white">
                        Welcome Back
                    </h1>
                </section>
                <LoginForm
                    redirect={redirect}
                    loginUnavailable={loginUnavailable}
                />
                <span className="font-medium text-sm text-white">
                    Not registered?{' '}
                    <DisabledLink
                        to={AppRoutes.signUp()}
                        disabled={loginUnavailable}
                        className="text-yellow underline"
                    >
                        Request an account
                    </DisabledLink>
                </span>
            </div>
        </LoginTransition>
    )
}

LoginPage.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }),
}
